import React from 'react';
import { AuthContext, type AuthContextValue } from './authContextShared';

export function useAuth(): AuthContextValue {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
